import {faArrowUpRightFromSquare, faChartBar, faUser, faUserGroup} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {NavGroupProps, NavItemDataProps} from '@minimal/components/nav-section';
import {getLinkByEnv} from '@workspaces/link';
import {appLinks} from '@workspaces/pilotage-rh/links';
import {WorkspaceList, workspacesBasePath} from '@workspaces/workspaces';

const basePath = workspacesBasePath[WorkspaceList.PILOTAGE_RH];

export const externalLink: NavItemDataProps = {
  title: 'menu.external.go-to-app',
  path: getLinkByEnv(appLinks),
  icon: <FontAwesomeIcon icon={faArrowUpRightFromSquare} />,
};

export const menu: NavGroupProps[] = [
  {
    items: [externalLink],
  },
  {
    subheader: 'menu.pilotage-rh.title',
    items: [
      {
        title: 'labels.accounts',
        path: `${basePath}/accounts`,
        icon: <FontAwesomeIcon icon={faUserGroup} />,
      },
      {
        title: 'labels.users',
        path: `${basePath}/users`,
        icon: <FontAwesomeIcon icon={faUser} />,
      },
      {
        title: 'labels.indicators',
        path: `${basePath}/indicators`,
        icon: <FontAwesomeIcon icon={faChartBar} />,
      },
    ],
  },
];
